import { NioApmPlus } from '@nio-fe/nio-apm-plus'
import util from '@/util/util'
import nativeHybrid from '@/util/nativeHybrid'

const release = process.env.VUE_APP_BUILD_RELEASE || 'local.1.0'
const modulePath = `/module_${util.getOfflineModuleCode()}`

export const initApmPlus = async Vue => {
	try {
		const userInfo = await nativeHybrid.getUserInfo()
		await NioApmPlus.createDefaultInstance({
			release, // 期望每次迭代更新一下
			userId: userInfo ? userInfo.account_id : 'unknown',
			context: [{ key: 'moduleVersion', value: release }],
			serviceEnv: util.getFormattedEnvStr(),
			serviceName: 'second-hand-app-pkg',
			plugins: {
				pageview: {
					routeMode: util.isOfflinePackage() ? 'hash' : 'history',
					extractPid: url => {
						// 获取当前页面的 pid
						const path1 = window.location.href.match(new RegExp(`${modulePath}(/[^?#]*)`))
						const path2 = window.location.href.match(/\/index.html#(\/[^?#]*)/)
						const path = path1 || path2

						return !!path ? path[1] : `noMatched:${url}`
					}
				},
				vueErrorHandler: {
					app: Vue // import Vue from 'vue'; vue 2 应用传这个
				}
			}
		})
	} catch (error) {
		// eslint-disable-next-line no-console
		console.error('init APM error', error)
	}
}
